export default [
  {
    path: '/boot-page',
    name: 'boot-page',
    component: () => import('@/views/boot-page/index.vue'),
    redirect: '/boot-page/home',
    children:[
      {
        path: 'home',
        name: 'boot-page-home',
        component: () => import('@/views/boot-page/home.vue'),
        meta: {
          title: '引导页',
          newTab: true,
          keepAlive: false,
          disableScroll: false,
          broadcast: false,
          unMenu: true,
        },
      },
      {
        path: 'real-name',
        name: 'boot-page-real-name',
        component: () => import('@/views/boot-page/real-name.vue'),
        meta: {
          title: '实名认证页',
          newTab: true,
          keepAlive: false,
          disableScroll: false,
          broadcast: false,
          unMenu: true,
          noNav: true,
        },
      },
      {
        path: 'launch-product',
        name: 'boot-page-launch-product',
        component: () => import('@/views/boot-page/launch-product.vue'),
        meta: {
          title: '开通产品',
          newTab: true,
          keepAlive: false,
          disableScroll: false,
          broadcast: false,
          unMenu: true,
          noNav: true,
        },
      },
      {
        path: 'preview-contract',
        name: 'boot-page-preview-contract',
        component: () => import('@/views/boot-page/preview-contract.vue'),
        meta: {
          title: '预览合同',
          newTab: true,
          keepAlive: false,
          disableScroll: false,
          broadcast: false,
          unMenu: false,
          noNav: true,
        },
      },
    ]
  },
];
